import React from "react";
import { Container, Box, Typography, Paper } from "@mui/material";

const About: React.FC = () => (
  <Box
    sx={{
      bgcolor: "#1E1E2F",
      color: "#FFFFFF",
      py: 8,
      userSelect: "none",
    }}
  >
    <Container maxWidth="lg">
      <Paper
        elevation={6}
        sx={{
          bgcolor: "#242435",
          p: { xs: 3, md: 6 },
          borderRadius: 2,
        }}
      >
        {/* Heading */}
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ color: "#e0e0e0", fontWeight: 600, mb: 1 }}
        >
          Our Story
        </Typography>

        {/* Banner image */}
        <Box
          component="img"
          src="/images/banner.jpeg"      /* or "/banner.jpeg" */
          alt="Store banner"
          sx={{
            width: "100%",
            height: { xs: 200, md: 300 },
            objectFit: "cover",
            borderRadius: 1,
            my: 3,
          }}
        />

        {/* Body text */}
        <Typography variant="body1" paragraph sx={{ color: "#C0C0C0" }}>
          Since 1990, we have been more than just a card shop. We are a place
          where collectors come first. Whether you are searching for rare
          finds, building your deck, or enjoying the nostalgia, we are here to
          make every visit memorable.
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: "#C0C0C0" }}>
          For over 35 years, our shop in Zion, Illinois has proudly welcomed
          collectors with friendly service, trusted advice, and a space that
          feels like home. We want every customer to leave happy and excited to
          return.
        </Typography>
        <Typography variant="body1" paragraph sx={{ color: "#C0C0C0" }}>
          The heart of our store is the community. It is a place where people
          come together to share their passion, trade stories, and discover
          something new every time.
        </Typography>
      </Paper>
    </Container>
  </Box>
);

export default About;
